import React from "react";
import styled from "styled-components";


export default styled.div`
    height: calc(100vh - 434px);
    overflow: scroll;
`;